var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-manifest-goods-info",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c("div", { staticClass: " operations" }, [
        _c("div", { staticClass: "triggers" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.canEdit, type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.new")))]
              ),
              _vm.isSeaHouseChannel
                ? _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.canEdit, type: "primary" },
                      on: { click: _vm.copy }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.canEdit, type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.edit2")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.canEdit, type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.lclView,
                      expression: "!lclView"
                    }
                  ],
                  attrs: { disabled: _vm.canEdit, type: "primary" },
                  on: { click: _vm.importFromContainer }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.GetPackingInformation")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.job.uuid && _vm.job.lclMasterUuid,
                      expression: "job.uuid&&job.lclMasterUuid"
                    }
                  ],
                  attrs: { disabled: _vm.innerIsEditing, type: "primary" },
                  on: { click: _vm.importFromLcLContainer }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "SeaExport.SynchronizeMainTicketPackingInformation"
                      )
                    )
                  )
                ]
              ),
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lclView,
                      expression: "lclView"
                    }
                  ],
                  staticStyle: {
                    display: "inline-block",
                    "padding-left": "5px"
                  },
                  attrs: {
                    disabled: !_vm.innerIsEditing,
                    action: _vm.URL.seaExport.manifestImportExcelLcl,
                    headers: {
                      sessionId: _vm.$store.getters.userInfo.sessionId
                    },
                    "show-file-list": false,
                    accept: ".xls, .xlsx",
                    "before-upload": _vm.beforeUpload,
                    "on-success": _vm.uploadSuccess
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.lclView,
                          expression: "lclView"
                        }
                      ],
                      attrs: {
                        slot: "trigger",
                        disabled: !_vm.innerIsEditing,
                        type: "primary"
                      },
                      slot: "trigger"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.manifestInfo.uuid,
                      expression: "manifestInfo.uuid"
                    }
                  ],
                  attrs: {
                    no: "cfmConfirm",
                    disabled: _vm.isEdit,
                    type: "primary"
                  },
                  on: { click: _vm.cfmBtnClickHandlers }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.manifestInfo.uuid,
                      expression: "manifestInfo.uuid"
                    }
                  ],
                  attrs: {
                    no: "SynchronizePackingInfo",
                    disabled: _vm.isEdit,
                    type: "primary"
                  },
                  on: { click: _vm.synchronizePackingInfo }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SynchronizePackingInfo")))]
              )
            ],
            1
          )
        ])
      ]),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px", "margin-top": "5px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.finalRowData
        },
        on: { gridReady: _vm.onGridReady }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  !_vm.isAddSpelling
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: !_vm.isEditing },
                            model: {
                              value: _vm.editDialog.form.soNo,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "soNo", $$v)
                              },
                              expression: "editDialog.form.soNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.containerNo") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        on: {
                          change: function($event) {
                            _vm.editDialog.form.containerNo = _vm.toUpperCaseTrim(
                              _vm.editDialog.form.containerNo
                            )
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.containerNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "containerNo", $$v)
                          },
                          expression: "editDialog.form.containerNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SealNo") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        on: {
                          change: function($event) {
                            _vm.editDialog.form.sealNo = _vm.toUpperCaseTrim(
                              _vm.editDialog.form.sealNo
                            )
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.sealNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "sealNo", $$v)
                          },
                          expression: "editDialog.form.sealNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.eqSize,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "eqSize", $$v)
                          },
                          expression: "editDialog.form.eqSize"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("queryJob.englishDescriptionOfGoods")
                      }
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            disabled: true,
                            value: _vm.editDialog.form.cargoEnglishName
                          }
                        },
                        [
                          _c("i", {
                            class: _vm.isEditing
                              ? "el-input__icon el-icon-edit"
                              : "el-input__icon el-icon-search",
                            staticStyle: {
                              "font-size": "12px",
                              cursor: "pointer",
                              color: "black"
                            },
                            attrs: { slot: "suffix" },
                            on: {
                              click: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("queryJob.englishDescriptionOfGoods"),
                                  _vm.editDialog.form.cargoEnglishName,
                                  function(val) {
                                    _vm.editDialog.form.cargoEnglishName = val
                                  }
                                )
                              }
                            },
                            slot: "suffix"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            disabled: true,
                            value: _vm.editDialog.form.mark
                          }
                        },
                        [
                          _c("i", {
                            class: _vm.isEditing
                              ? "el-input__icon el-icon-edit"
                              : "el-input__icon el-icon-search",
                            staticStyle: {
                              "font-size": "12px",
                              cursor: "pointer",
                              color: "black"
                            },
                            attrs: { slot: "suffix" },
                            on: {
                              click: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.editDialog.form.mark,
                                  function(val) {
                                    _vm.editDialog.form.mark = val
                                  }
                                )
                              }
                            },
                            slot: "suffix"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "HSCode" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            disabled: true,
                            value: _vm.editDialog.form.hsCode
                          }
                        },
                        [
                          _c("i", {
                            class: _vm.isEditing
                              ? "el-input__icon el-icon-edit"
                              : "el-input__icon el-icon-search",
                            staticStyle: {
                              "font-size": "12px",
                              cursor: "pointer",
                              color: "black"
                            },
                            attrs: { slot: "suffix" },
                            on: {
                              click: function($event) {
                                return _vm.showAdvanceTextDialog(
                                  "HSCode",
                                  _vm.editDialog.form.hsCode,
                                  function(val) {
                                    _vm.editDialog.form.hsCode = val
                                  }
                                )
                              }
                            },
                            slot: "suffix"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.packing,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "packing", $$v)
                          },
                          expression: "editDialog.form.packing"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Quantity") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          disabled: !_vm.isEditing,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "quantity", $$v)
                          },
                          expression: "editDialog.form.quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isSeaHouseChannel
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Weight") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              disabled: !_vm.isEditing,
                              controls: false,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.weight = _vm.roundHalfUp(
                                  _vm.editDialog.form.weight,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "weight", $$v)
                              },
                              expression: "editDialog.form.weight"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Weight") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              min: 0,
                              disabled: !_vm.isEditing,
                              controls: false,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.weight = _vm.roundHalfUp(
                                  _vm.editDialog.form.weight,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "weight", $$v)
                              },
                              expression: "editDialog.form.weight"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "30%" },
                              model: {
                                value: _vm.editDialog.form.weightUnit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "weightUnit",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.weightUnit"
                              }
                            },
                            _vm._l(_vm.WEIGHT_UNIT, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.code, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                  _vm.isSeaHouseChannel
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              disabled: !_vm.isEditing,
                              controls: false,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.cubage = _vm.roundHalfUp(
                                  _vm.editDialog.form.cubage,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.cubage,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "cubage", $$v)
                              },
                              expression: "editDialog.form.cubage"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              min: 0,
                              disabled: !_vm.isEditing,
                              controls: false,
                              precision: 3
                            },
                            on: {
                              blur: function($event) {
                                _vm.editDialog.form.cubage = _vm.roundHalfUp(
                                  _vm.editDialog.form.cubage,
                                  3
                                )
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.cubage,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "cubage", $$v)
                              },
                              expression: "editDialog.form.cubage"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "30%" },
                              model: {
                                value: _vm.editDialog.form.cubageUnit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "cubageUnit",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.cubageUnit"
                              }
                            },
                            _vm._l(_vm.CUBAGE_UNIT, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.code, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Remark") } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            disabled: true,
                            value: _vm.editDialog.form.goodsRemark
                          }
                        },
                        [
                          _c("i", {
                            class: _vm.isEditing
                              ? "el-input__icon el-icon-edit"
                              : "el-input__icon el-icon-search",
                            staticStyle: {
                              "font-size": "12px",
                              cursor: "pointer",
                              color: "black"
                            },
                            attrs: { slot: "suffix" },
                            on: {
                              click: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("CargoMsg.Cargo_Remark"),
                                  _vm.editDialog.form.goodsRemark,
                                  function(val) {
                                    _vm.checkGoodsRemark(val)
                                  }
                                )
                              }
                            },
                            slot: "suffix"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "UN Code" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.danUNNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "danUNNo", $$v)
                          },
                          expression: "editDialog.form.danUNNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DangerousClass") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.danClassNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "danClassNo", $$v)
                          },
                          expression: "editDialog.form.danClassNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PrimaryCustomsNo") } },
                    [
                      _c("el-checkbox", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.masterSoNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "masterSoNo", $$v)
                          },
                          expression: "editDialog.form.masterSoNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.DangerousGoodsContact")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.dngrContactUser,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "dngrContactUser",
                              $$v
                            )
                          },
                          expression: "editDialog.form.dngrContactUser"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.DangerousGoodsContactPhoneNumber"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editDialog.form.dngrContactNumber,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "dngrContactNumber",
                              $$v
                            )
                          },
                          expression: "editDialog.form.dngrContactNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ediStatus") } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          value:
                            _vm.editDialog.title === _vm.$t("common.btn.new")
                              ? _vm.$t("SeaExport.notSend")
                              : _vm.ColumnUtils.ediStateFunction(
                                  _vm.editDialog.form.ediStatus
                                )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.innerIsEditing,
                      expression: "innerIsEditing"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.innerIsEditing
                        ? _vm.$t("common.btn.cancel")
                        : _vm.$t("common.btn.close")
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { disabled: !_vm.isEditing, type: "textarea", rows: "10" },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditing,
                      expression: "isEditing"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }